import React, { useState, useEffect } from 'react';
import { Widget } from '@digital/ui';
import { ReportCapexManeger } from '../../api/relatorios';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';


interface CapexManagementGraficoProps {
  data: ReportCapexManeger;
}

const CapexManagementGrafico = (props: CapexManagementGraficoProps) => {
  const { data } = props;

  useEffect(() => {
    const valores = document.getElementsByTagName('tspan');
    if (valores && valores.length > 0) {
      for (let index = 0; index < valores.length; index++) {
        const element = valores[index];
        if (element.innerHTML == 'Values') {
          element.innerHTML = '';
          break;
        }
      }
    }
  }, [])

  const optionsColumn: Highcharts.Options = {
    chart: {
      type: 'column',
      inverted: true,
    },
    title: {
      text: 'CapEx Management',
    },
    tooltip: {
      enabled: false,
      headerFormat: '<b>{point.x}</b><br/>',
      formatter: function () {
        return '<b>' + this.y.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + '</b>';
      },
    },
    colors: [
      '#08340D',
      '#006129',
      '#80BDA6',
      '#E1865C',
      '#8C0400',
    ],
    plotOptions: {
      column: {
        colorByPoint: true,
        dataLabels: {
          enabled: true,
          formatter: function () {
            return '<b>' + this.y.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + '</b>';
          },
        }
      }
    },
    xAxis: {
      categories: ['CAPEX TOTAL', 'CONTRATADO', 'EXECUTADO', 'REQUISITADO', 'CONTRATADO + REQUISTADO'],
      title: {
        text: null,
      },
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        data: [
          data.totalCapex,
          data.totalContratado,
          data.totalExecutado,
          data.totalRequisitado,
          data.contratadoMaisRequisitado
        ]
      }
    ],
  };

  return (
    <Widget title="" span={12} actions={[]}>
      <HighchartsReact
        highcharts={Highcharts}
        options={optionsColumn}
        {...props} />
    </Widget>
  );
};

export default CapexManagementGrafico;